import React from 'react';
import FaceGraphic from './components/FaceGraphic';
import styled from 'styled-components';
import GlobalFonts from './fonts/font';

const Container = styled.div`
  max-width: 100%;
  margin: 0;
  h2 {
    margin-top: 0;
  }
`;

const App: React.FC = () => {
  return (
    <Container>
      <GlobalFonts />
      <FaceGraphic />
    </Container>
  );
};

export default App;
